var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styles from "./DevelopmentOpportunitiesBar.module.scss";
import { Icon, IconName, IconSize, Link } from "@eightfold.ai/octuple";
var getStatusByScore = function (score) {
    if (score >= 0 && score < 80) {
        return "act";
    }
    if (score >= 80 && score <= 90) {
        return "watch";
    }
    if (score > 90 && score <= 100) {
        return "maintain";
    }
    return null;
};
export var getFactorScoreColor = function (score, colors) {
    var status = getStatusByScore(score);
    var statusIndexMap = {
        act: 0,
        watch: 1,
        maintain: 2,
    };
    if (status !== null) {
        var index = statusIndexMap[status];
        return {
            background: colors === null || colors === void 0 ? void 0 : colors[index],
        };
    }
    return {};
};
var groupArray = function (arr, size) {
    return Array.from({ length: Math.ceil((arr === null || arr === void 0 ? void 0 : arr.length) / size) }, function (_, i) {
        return arr.slice(i * size, i * size + size);
    });
};
var DevelopmentOpportunitiesBarData = function (_a) {
    var title = _a.title, headerIconColor = _a.headerIconColor, data = _a.data, colors = _a.colors;
    return (_jsxs("div", __assign({ className: styles.container }, { children: [_jsxs("div", __assign({ className: styles.header }, { children: [_jsx(Icon, { size: IconSize.Small, classNames: styles.headerIconStyle, path: IconName.mdiLightbulbOnOutline, style: { background: headerIconColor } }), _jsx("span", __assign({ className: styles.text, style: {
                            fontSize: "18px",
                            lineHeight: "28px",
                            fontFamily: "var(--font-stack-full-regular)",
                        } }, { children: title }))] })), _jsx("div", __assign({ className: styles.content }, { children: groupArray(data, 3).map(function (group, rowIndex) { return (_jsx("div", __assign({ className: styles.rowWrapper }, { children: group.map(function (item, i) {
                        var isFirst = i === 0;
                        var isLast = i === group.length - 1;
                        return (_jsxs("div", __assign({ className: styles.itemDetails }, { children: [_jsxs("div", __assign({ className: styles.itemStyle, style: {
                                        borderRadius: group.length === 1
                                            ? "10px"
                                            : isFirst
                                                ? "10px 0 0 10px"
                                                : isLast
                                                    ? "0 10px 10px 0"
                                                    : "0",
                                    } }, { children: [_jsxs("div", __assign({ className: styles.itemLeft }, { children: [_jsx("span", __assign({ className: styles.text }, { children: item.function_label + " + " + item.level_label })), _jsx(Link
                                                // onClick={() =>
                                                //   window.open(
                                                //     item.link,
                                                //     "_blank",
                                                //     "noopener,noreferrer"
                                                //   )
                                                // }
                                                , { children: _jsx(Icon, { classNames: styles.icon, path: IconName.mdiChevronRight }) })] })), _jsxs("div", __assign({ className: styles.itemRight }, { children: [_jsx("span", __assign({ className: styles.percentage, style: __assign({}, getFactorScoreColor(item.value === 0 ? 0 : Math.round(item.value), colors !== undefined ? colors : [])) }, { children: item.value === 0
                                                        ? 0 + "%"
                                                        : Math.round(item.value) + "%" })), _jsx("div", { className: styles.divider }), _jsxs("div", __assign({ className: styles.users }, { children: [_jsx(Icon, { classNames: styles.icon, path: IconName.mdiAccountOutline, style: { marginRight: "3px" } }), _jsx("span", __assign({ className: styles.text, style: {
                                                                fontWeight: 350,
                                                                marginTop: "1px",
                                                                fontFamily: "var(--font-stack-full-book)",
                                                            } }, { children: item.leaders }))] }))] }))] })), i < group.length - 1 && (_jsx("div", { className: styles.itemSeparator }))] }), i));
                    }) }), rowIndex)); }) }))] })));
};
var DevelopmentOpportunitiesBar = function (_a) {
    var title = _a.title, headerIconColor = _a.headerIconColor, data = _a.data, colors = _a.colors;
    return (_jsx(_Fragment, { children: _jsx(DevelopmentOpportunitiesBarData, { "data-testid": "DevelopmentOpportunity", title: title, headerIconColor: headerIconColor, data: data, colors: colors }) }));
};
export default DevelopmentOpportunitiesBar;
